export default "{\n    \"noDataMessage\": \"Aucune donnée disponible.\"\n}\n"